import { Component, Input, OnInit, OnChanges, HostBinding, Output, EventEmitter, Injector, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { QueryCondition } from '../../entity/querycondition';
import { DateRangeValue } from '../../entity/conditionvalue/daterangevalue';
import { SolutionService } from '../../service/solution.service';

@Component({
    selector: 'app-filter-daterange',
    templateUrl: './daterange.component.html'
})

export class DateRangeComponent implements OnInit, OnChanges {

    /**
     * QueryCondition类型
     */
    @Input() item: any;
    @Input() autoLabel: boolean;
    @Input() disabled: boolean;
    @Input() showTime: boolean;
    @Input() showType: string;
    @Output('searchHandle') searchHandle = new EventEmitter();

    startTime: Date;
    endTime: Date;
    //TODO: need 2 placeholder text for date range
    // rangeDate = {
    //     begin:null,
    //     end:null
    // };
    /**判断是否是在扩展区域展示 */
    extend: boolean = false;
    /**判断是否显示label */
    showlabel: boolean = true;

    rangeDate: string;
    placeholder: string;
    beginPlaceHolder: string;
    endPlaceHolder: string;
    dateFormat: string;
    returnFormat: string;
    // showType:string;

    @HostBinding('class.filter-item-wrap')
    get isExtend(): boolean {
        return !this.extend && this.autoLabel;
    }
    @HostBinding('class.filter-item-hiddenlabel')
    get hidenLabel(): boolean {
        return !this.showlabel;
    }
     /**
     * 某个字段发生值变化事件时，需要同步清空的字段，可能不是当前字段
     */
    @Input() changeFields: Array<string> = [];
    constructor(private solutionService: SolutionService, private injector: Injector, private cdr: ChangeDetectorRef) { }

    ngOnInit(): void {
        this.initDate();
        if (this.item) {
            const type = Object.prototype.toString.call(this.item.placeHolder);
            if (type == '[object Undefined]') {
                if (this.item.control && this.item.control.hasOwnProperty('placeholder')) {
                    this.placeholder = this.item.control.placeholder;
                }
            }
            else {
                this.placeholder = this.item.placeHolder;
            }
            const beginplac = Object.prototype.toString.call(this.item.beginPlaceHolder);
            if (beginplac == '[object Undefined]') {
                if (this.item.control && this.item.control.hasOwnProperty('placeholder')) {
                    this.beginPlaceHolder = this.item.control.beginPlaceHolder;
                }
            }
            else {
                this.beginPlaceHolder = this.item.beginPlaceHolder;
            }
            const endplac = Object.prototype.toString.call(this.item.endPlaceHolder);
            if (endplac == '[object Undefined]') {
                if (this.item.control && this.item.control.hasOwnProperty('placeholder')) {
                    this.endPlaceHolder = this.item.control.endPlaceHolder;
                }
            }
            else {
                this.endPlaceHolder = this.item.endPlaceHolder;
            }
            // this.showType = this.item.control.showType;
        }
        if (this.item && this.item.control && this.item.control.hasOwnProperty('isExtend')) {
            this.extend = this.item.control.isExtend;
            if (!this.extend) {
                this.showlabel = this.item.control.showLabel;
            }
        }

        this.solutionService.addFilterEditorInstance(this.item.fieldCode, this);


        (this.item.value as DateRangeValue).clear$.subscribe(() => {
            this.rangeDate = '';
        });

        // this.cdr.detectChanges();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // this.initDate();
        if (changes['changeFields'] && changes['changeFields'].currentValue && !changes['changeFields'].firstChange) {
            const isChange = changes['changeFields'].currentValue.some(field => field == this.item.fieldCode);
            if (isChange) {
                let beginValue = this.item.value && this.item.value.startTime ? this.item.value.startTime.toString().trim() : '';
                let endValue = this.item.value && this.item.value.endTime ? this.item.value.endTime.toString().trim() : '';
                this.rangeDate = `${beginValue}~${endValue}`;
            }
        }
    }

    initDate() {
        if (this.item && this.item.control && this.item.control.hasOwnProperty('format')) {
            let itemDateFormat = this.item.control.format;
            if (this.showTime) {
                if (itemDateFormat.length > 0 && itemDateFormat.indexOf('HH:mm') == -1) {
                    itemDateFormat = itemDateFormat + ' HH:mm:ss';
                }
            }
            const format = this.showTime ? 'yyyy-MM-dd HH:mm:ss' : (this.showType == '2' ? 'yyyy-MM' : (this.showType == '3' ? 'yyyy' : 'yyyy-MM-dd'));
            this.returnFormat = format;
            this.dateFormat = itemDateFormat ? itemDateFormat : format;
        }
        const rangeDateValue: DateRangeValue = this.item && this.item.value;
        if (rangeDateValue.startTime && rangeDateValue.endTime) {
            this.rangeDate = `${rangeDateValue.startTime}~${rangeDateValue.endTime}`;
        }
    }

    getDate(dateString: Date): Date {
        // let arr1:Array<any> = dateString.split(" "); 
        // let sdate = arr1[0].split('-'); 
        // let date = new Date(sdate[0], sdate[1]-1, sdate[2]);
        let date = new Date(dateString);
        return date;
    }

    onDateChange(event: any) {
        if (event) {
            (this.item.value as DateRangeValue).startTime = event.returnFormatted.split('~')[0];
            (this.item.value as DateRangeValue).endTime = event.returnFormatted.split('~')[1];
        } else {
            // this.item.value = new DateRangeValue();
            this.item.value.startTime = '';
            this.item.value.endTime = '';
        }
        if (this.disabled) { return; }
        this.searchHandle.emit(event);
    }
    getConditionItemTitle(field: QueryCondition) {
        return this.solutionService.getConditionItemTitle(field);
    }
}
